import { useLocalStorage, useStorage } from '@vueuse/core'
import queryWishlists from '@/graphql/queries/queryWishlists.graphql'

async function wishlistCounter() {
    if (process.server || !navigator.cookieEnabled) {
        return
    }

    const { isUserLoggedIn } = useUser()

    if (!(await isUserLoggedIn())) {
        return
    }

    const mageCacheStorage: Record<string, any> = useLocalStorage('mage-cache-storage', {})

    if (mageCacheStorage.value?.wishlist) {
        return
    }

    const { data } = await useAsyncQuery(queryWishlists)

    const counter = data.value?.wishlists[0].itemCount

    const event = new CustomEvent('WISHLIST_PRODUCT_ADD', {
        detail: {
            item_count: counter,
        },
    })

    window.dispatchEvent(event)
    useStorage(
        'mage-cache-storage',
        {
            wishlist: {
                counter,
            },
        },
        localStorage,
        { mergeDefaults: true },
    )
}

export default wishlistCounter
